// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__19EG1","fluid":"Container_fluid__8CWyn"};